export type ManagementSortOrder = 'asc' | 'desc';

export type ManagementTableLazyEvent = {
  first?: number | null;
  rows?: number | null;
  sortField?: string | string[] | null;
  sortOrder?: number | null;
};

export type ManagementTableLazyState<TSortField extends string> = {
  first: number;
  rows: number;
  sortField?: TSortField;
  sortOrder?: ManagementSortOrder;
};

export function getManagementTableLazyState<TSortField extends string>(
  event: ManagementTableLazyEvent,
  currentRows: number,
  isSortField: (field?: string | string[] | null) => field is TSortField
): ManagementTableLazyState<TSortField> {
  return {
    first: event.first ?? 0,
    rows: event.rows ?? currentRows,
    sortField: isSortField(event.sortField) ? event.sortField : undefined,
    sortOrder: event.sortOrder === 1 ? 'asc' : event.sortOrder === -1 ? 'desc' : undefined
  };
}

export function getPreviousPageFirst(total: number, rows: number): number {
  return Math.floor((total - 1) / rows) * rows;
}
